/* Saatdaana image zoom viewer (v11). Needs window.SD and window.SDX from sd-product.js */
(function () {
  var S = window.SD, X = window.SDX;
  function $(id) { return document.getElementById(id); }
  var pz = $('Pz');
  if (!pz || !S || !X) return;
  var stage = $('PzStage'), img = $('PzImg'), count = $('PzCount'), range = $('PzRange');
  var scale = 1, tx = 0, ty = 0, idx = 0, MIN = 1, MAX = 5;
  var pointers = {}, startDist = 0, startScale = 1, swipeStartX = 0, lastTap = 0, moved = false;
  var mainBtn = X.mainBtn;

  function bounds() { var w = img.offsetWidth, h = img.offsetHeight; return { x: Math.max(0, (w * scale - w) / 2), y: Math.max(0, (h * scale - h) / 2) }; }
  function clamp() { var b = bounds(); tx = Math.max(-b.x, Math.min(b.x, tx)); ty = Math.max(-b.y, Math.min(b.y, ty)); }
  function render() { img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; range.value = scale; stage.classList.toggle('is-zoomed', scale > 1.01); }
  function anim(on) { img.classList.toggle('no-anim', !on); }
  function zoomAt(ns, cx, cy) {
    ns = Math.min(MAX, Math.max(MIN, ns));
    var r = stage.getBoundingClientRect(), px = (cx == null ? r.left + r.width / 2 : cx) - (r.left + r.width / 2), py = (cy == null ? r.top + r.height / 2 : cy) - (r.top + r.height / 2);
    tx = px - (px - tx) * (ns / scale); ty = py - (py - ty) * (ns / scale); scale = ns;
    if (scale <= 1.001) { scale = 1; tx = 0; ty = 0; } clamp(); render();
  }
  function show(i) {
    idx = (i + S.images.length) % S.images.length; img.classList.add('is-loading');
    img.onload = function () { img.classList.remove('is-loading'); };
    img.src = S.images[idx].large; img.alt = S.images[idx].alt;
    count.textContent = S.images.length > 1 ? (idx + 1) + ' / ' + S.images.length : '';
    anim(false); scale = 1; tx = 0; ty = 0; render(); requestAnimationFrame(function () { anim(true); });
  }
  function open(i) { show(i); pz.classList.add('is-open'); document.body.classList.add('overflow-hidden'); $('PzClose').focus(); }
  function close() { pz.classList.remove('is-open'); document.body.classList.remove('overflow-hidden'); X.setMain(idx); if (mainBtn) mainBtn.focus(); }

  if (mainBtn) mainBtn.addEventListener('click', function () { open(X.getActive()); });
  $('PzClose').addEventListener('click', close);
  $('PzIn').addEventListener('click', function () { anim(true); zoomAt(scale + 0.75); });
  $('PzOut').addEventListener('click', function () { anim(true); zoomAt(scale - 0.75); });
  $('PzReset').addEventListener('click', function () { anim(true); zoomAt(1); });
  range.addEventListener('input', function () { anim(false); zoomAt(parseFloat(range.value)); });
  var prev = $('PzPrev'), next = $('PzNext');
  if (prev) prev.addEventListener('click', function () { show(idx - 1); });
  if (next) next.addEventListener('click', function () { show(idx + 1); });

  stage.addEventListener('wheel', function (e) { e.preventDefault(); anim(false); zoomAt(scale * Math.exp(-e.deltaY * 0.0022), e.clientX, e.clientY); }, { passive: false });
  stage.addEventListener('dblclick', function (e) { anim(true); zoomAt(scale > 1.2 ? 1 : 2.6, e.clientX, e.clientY); });

  function two() { var k = Object.keys(pointers); return { a: pointers[k[0]], b: pointers[k[1]] }; }
  function dist() { var p = two(); return Math.hypot(p.a.x - p.b.x, p.a.y - p.b.y); }
  stage.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('.pz__nav')) return;
    try { stage.setPointerCapture(e.pointerId); } catch (x) {}
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY, px: e.clientX, py: e.clientY };
    swipeStartX = e.clientX; moved = false; anim(false);
    if (Object.keys(pointers).length === 2) { startDist = dist(); startScale = scale; }
    stage.classList.add('is-dragging');
  });
  stage.addEventListener('pointermove', function (e) {
    var p = pointers[e.pointerId]; if (!p) return;
    var n = Object.keys(pointers).length, dx = e.clientX - p.x, dy = e.clientY - p.y;
    p.x = e.clientX; p.y = e.clientY;
    if (Math.abs(e.clientX - p.px) + Math.abs(e.clientY - p.py) > 6) moved = true;
    if (n === 2 && startDist) { var t = two(); zoomAt(startScale * (dist() / startDist), (t.a.x + t.b.x) / 2, (t.a.y + t.b.y) / 2); }
    else if (n === 1 && scale > 1) { tx += dx; ty += dy; clamp(); render(); }
  });
  function endPointer(e) {
    var p = pointers[e.pointerId]; if (!p) return;
    var n = Object.keys(pointers).length;
    if (n === 1) {
      var dx = e.clientX - swipeStartX;
      if (scale <= 1.01 && Math.abs(dx) > 70 && S.images.length > 1) { show(dx < 0 ? idx + 1 : idx - 1); }
      else if (!moved) { var now = Date.now(); if (now - lastTap < 300) { anim(true); zoomAt(scale > 1.2 ? 1 : 2.6, e.clientX, e.clientY); lastTap = 0; } else { lastTap = now; } }
    }
    delete pointers[e.pointerId]; startDist = 0; anim(true);
    if (!Object.keys(pointers).length) stage.classList.remove('is-dragging');
  }
  stage.addEventListener('pointerup', endPointer);
  stage.addEventListener('pointercancel', endPointer);
  window.addEventListener('resize', function () { clamp(); render(); });

  document.addEventListener('keydown', function (e) {
    if (!pz.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === '+' || e.key === '=') { anim(true); zoomAt(scale + 0.75); }
    else if (e.key === '-') { anim(true); zoomAt(scale - 0.75); }
    else if (e.key === 'ArrowLeft') { if (scale > 1.01) { tx += 60; clamp(); render(); } else show(idx - 1); }
    else if (e.key === 'ArrowRight') { if (scale > 1.01) { tx -= 60; clamp(); render(); } else show(idx + 1); }
  });
})();